import { axiosInstance } from './api';
import * as ActionTypes from '../store/ActionTypes';

export const actionCreators = {
    getEnrollments: (enrollments) => ({ type: ActionTypes.getEnrollments, payload: enrollments }),
    getEnrollment: (enrollment) => ({ type: ActionTypes.getEnrollment, payload: enrollment }),
    updateEnrollment: (enrollment) => ({ type: ActionTypes.updateEnrollment, payload: enrollment }),
    getStateProvinces: (stateProvinces) => ({ type: ActionTypes.getStateProvinces, payload: stateProvinces }),
    updateResponse: (response) => ({ type: ActionTypes.updateResponse, payload: response }),
    getRecipients: (recipients) => ({ type: ActionTypes.getRecipients, payload: recipients }),
    getRecipient: (recipient) => ({ type: ActionTypes.getRecipient, payload: recipient }),
    updateRecipient: (recipient) => ({ type: ActionTypes.updateRecipient, payload: recipient }),
    getBySaleId: (recipient) => ({ type: ActionTypes.getRecipients, payload: recipient }),
    resendEmail: (response) => ({ type: ActionTypes.resendEmailRecipient, payload: response }),
    sendToRouter: (response) => ({ type: ActionTypes.sendToRouter, payload: response })
}

export const getStateProvinces = (callback, context) => {
    return dispatch => {
        const url = `StateProvince/GetStateProvincesAsync`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.updateEnrollment(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getBySaleId = (callback, context, id) => {
    return dispatch => {
        const url = `recipient/getBySale/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getRecipients(response.data.data))
            callback(response, context);
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const getEnrollments = (callback, context, filter) => {
    return dispatch => {
        const url = `Enrollment/SearchAsync?filter=${filter}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getEnrollments(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getEnrollment = (callback, context, id) => {
    return dispatch => {
        const url = `Enrollment/GetByEnrollmentId/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getEnrollments(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}


export const updateEnrollment = (enrollment) => {
    return dispatch => {
        const url = `Enrollment/PutAsync`;
        return axiosInstance().put(url, enrollment).then(response => {
            dispatch(actionCreators.updateEnrollment(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

/*Recipients*/
export const getRecipients = (callback, context, filter) => {
    return dispatch => {
        const url = `Recipient/SearchAsync?filter=${filter}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getRecipient(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const getRecipientsPaginated = (filter, pageNumber, pageSize, orderBy, descending, saleId) => {
    if (pageNumber !== 0)
        pageNumber = pageNumber - 1;
    const url = `Recipient/GetGiftsByFilterPaginatedAsync?filter=${filter}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderBy=${orderBy}&descending=${descending}&saleId=${saleId}`;
    return axiosInstance().get(url);
}

export const getRefundedGiftsReport = (clubId, branchId, startDate, endDate) => {
    const url = `Recipient/GetRefundedGiftsReport?clubId=${clubId}&branchId=${+branchId > 0 ? branchId : ''}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getPromoCodeUsageReport = (clubId, branchId, startDate, endDate) => {
    const url = `Recipient/GetPromoCodeUsageReport?clubId=${clubId}&branchId=${+branchId > 0 ? branchId : ''}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getSalesReport = (clubId, branchId, startDate, endDate) => {
    const url = `Recipient/GetSalesReport?clubId=${clubId}&branchId=${+branchId > 0 ? branchId : ''}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getEnrolledGiftsReport = (clubId, branchId, startDate, endDate) => {
    const url = `Enrollment/GetEnrolledGiftsReport?clubId=${clubId}&branchId=${+branchId > 0 ? branchId : ''}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getCrossTerritorySalesReport = (clubId, branchId, startDate, endDate) => {
    const url = `Recipient/GetCrossTerritoryReport?clubId=${clubId}&branchId=${+branchId > 0 ? branchId : ''}&startDate=${startDate}&endDate=${endDate}`;
    return axiosInstance().get(url);
}

export const getRecipient = (callback, context, id) => {
    return dispatch => {
        const url = `Recipient/GetByRecipientId/${id}`;
        return axiosInstance().get(url).then(response => {
            dispatch(actionCreators.getRecipients(response.data.data))
            callback(response, context);
        }).catch(response => callback(response.response, context));
    }
}

export const updateRecipient = (recipient) => {
    return dispatch => {
        if (recipient.enrollment && !recipient.enrollment.Exists)
            recipient.enrollment = null;
        const url = `Recipient/PutAsync`;
        return axiosInstance().put(url, recipient).then(response => {
            dispatch(actionCreators.updateRecipient(response))
            dispatch(actionCreators.updateResponse(response))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponse = (response) => {
    return dispatch => {
        dispatch(actionCreators.updateResponse(response));
    }
}

export const resendEmailService = (callback, context, id) => {
    return dispatch => {
        const url = `Recipient/PutResendEmailAsync/${id}`;
        return axiosInstance().put(url).then(response => {
            dispatch(actionCreators.resendEmail(response.data))
            callback(response, context)
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const sendToRouter = (id) => {
    return dispatch => {
        const url = `Enrollment/SendToRouter?enrollmentId=${id}`;
        return axiosInstance().post(url).then(response => {
            dispatch(actionCreators.sendToRouter(response.data))
        }).catch(response => { dispatch(actionCreators.updateResponse(response.response)) });
    }
}

export const updateResponseResendEmail = (response) => {
    return dispatch => {
        dispatch(actionCreators.resendEmail(response));
    }
}

export const updateRouter = (response) => {
    return dispatch => {
        dispatch(actionCreators.sendToRouter(response));
    }
}
